import type { UserMappingMap } from '../../common/types';
import type { CSVMetadata } from '../../common/utils/csv-import-clients/types';
import type { TransformedCSVMetadata } from './types';

export const transformToUserMappingsState = ({
	issueCount,
	users,
	missingUserMapping,
}: CSVMetadata): TransformedCSVMetadata => {
	const userMappingMap: UserMappingMap = {};

	users.forEach((user) => {
		userMappingMap[user.userKey] = {
			...user,
		};
	});

	const preFilledUserCount = users.filter((user) => !!user.userValue).length;

	const missingUsers = missingUserMapping.map((user) => user.cellValue);

	return {
		issueCount,
		userMapping: userMappingMap,
		preFilledUserCount,
		missingUsers,
	};
};
